"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = fixedCenter;
function fixedCenter() {
  return /*css*/"\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n  ";
}